<template>
  <div class="threeImg">
      <div class="Containt">
        <ul :style="{'left':calleft + 'px', width: widthData + 'px'} " v-on:mouseover="stopmove()" v-on:mouseout="move()" class="imgBoxoul">
          <li v-for="(item,index) in imgList" :key="index" 
          
          :style="{backgroundImage: `url(${item})`, backgroundSize: 'cover'}"
          
           @click="imgClick(index)" ref="lis">
            <!-- <img :src="item" /> -->
          </li>
        </ul>
      </div>
    </div>
</template>
 
<script>
export default {
  props: ["list"],
  data() {
    return {
      calleft: 0,
      speed:1,
      imgList: []
    };
  },
 
  created() {
    this.move();
  },
  mounted() {
    this.imgList = [...this.list, ...this.list]
  },
  computed: {
    widthData(){
      return 240 * Number(this.imgList.length*2)
    }
  },
  methods: {
    imgClick(index) {
        this.$imagePreview({
            images: this.imgList,
            index,
        })
    },
    gotodetails() {
        console.log(111)
    },
    //移动
    move() {
      this.timer = setInterval(this.starmove, 20);
    },
    //开始移动
    starmove() {
      this.calleft -= 1.2;//*this.speed
      if (this.calleft <= -1150) {
        this.calleft = 0;
      }
    },
    //鼠标悬停时停止移动
    stopmove() {
      clearInterval(this.timer);
    },
    //点击按钮左移
    zuohua() {
      this.calleft -= 240;//this.speed = 1
      if (this.calleft <= -1200) {
        this.calleft = 0;
      }
    },
    //点击按钮右移
    youhua() { //this.speed = -1
      this.calleft += 240;
      if (this.calleft >= 0) {
        this.calleft = -1200;
      }
    },
    
  }
};
</script>
 
<style>
 
.threeImg {
  position: relative;
}
 
.threeImg .Containt ul {
  margin: 0 auto;
  width: 2400px;
  position: absolute;
  left: 0px;
  cursor: pointer;
  height: 100%;
  z-index: 10;
}
 
.threeImg .Containt ul li {
  float: left;
  width: 220px;
  height: 190px;
  margin-right: 20px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #ffffff;
}
 
.threeImg .Containt ul li img {
  width: 100%;
  height: 190px;
}
 
.Containt {
  position: relative;
  /* padding: 60px 0; */
  overflow-y: auto;
  /* width: 1200px; */
  height: 190px;
  overflow: hidden;
  margin: 0 auto;
}
 
.iconleft {
  position: absolute;
  width: 20px;
  height: 80px;
  top: 35%;
  left: 15%;
  z-index: 99999;
  cursor: pointer;
}
 
.iconright {
  position: absolute;
  top: 37%;
  right: 15%;
  width: 20px;
  height: 80px;
  z-index: 99999;
  -webkit-transform:rotate(180deg);
  cursor: pointer;
}
</style>